import React, { useEffect } from "react";
import { useDeleteUser } from "@/features/user/hooks/use-delete-user";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { Checkbox } from "@/shared/components/check-box/check-box";

interface Props {
  onTapCloseModal: () => void;
}

// 利用者削除モーダル
export const DeleteUserModal = ({ onTapCloseModal }: Props) => {
  const {
    check,
    isActiveDeleteButton,
    onChangeDeleteButtonState,
    onClickDelete,
    onTapCheckBox,
  } = useDeleteUser();

  useEffect(() => {
    onChangeDeleteButtonState(check);
  }, [check]);

  return (
    <BasePageModal
      title="アカウント削除"
      className="md-user-delete"
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <BaseRoundButton
          buttonText="削除"
          onClick={onClickDelete}
          isActive={isActiveDeleteButton}
        />
      }
    >
      <h2>本当にこのアカウントを削除しますか？</h2>
      <p>このアカウントに登録されたすべてのデータが削除されます<br />
         1度削除したアカウントは復元することはできません
      </p>
      <Checkbox
        label={"アカウントを削除します。よろしいですか？"}
        checked={check}
        handleChange={onTapCheckBox}
        className="deleteAccount"
      />
    </BasePageModal>
  );
};
